import { z } from "zod";

export const DocumentSerieDefinitionFieldsSchema = z.object({
  id: z.number(),
  documentType: z.number(),
  numberingSchema: z.string(),
  documentSubtype: z.any(),
  numberingType: z.number(),
  positionsActive: z.any(),
  priority: z.number(),
  availableTemplates: z.any(),
  account: z.any(),
  currency: z.string(),
  stages: z.any(),
  alternativeCompanyData: z.any(),
  storehouse: z.object({
    id: z.number(),
    shortName: z.string(),
    name: z.string(),
    description: z.string(),
    isActive: z.boolean(),
  }),
  paymentRegister: z.object({
    id: z.number(),
    paymentRegisterId: z.number(),
    name: z.string(),
    code: z.string(),
    type: z.number(),
  }),
});
export const PartialDocumentSerieDefinitionFieldsSchema =
  DocumentSerieDefinitionFieldsSchema.deepPartial();

export const DocumentSerieDefinitionExtraFieldsSchema = z.object({
  availableTemplates: z.any(),
  templates: z.any(),
});
export const PartialDocumentSerieDefinitionExtraFieldsSchema =
  DocumentSerieDefinitionExtraFieldsSchema.deepPartial();

export const DocumentSerieDefinitionSchema = z.intersection(
  DocumentSerieDefinitionFieldsSchema,
  DocumentSerieDefinitionExtraFieldsSchema
);

export type DocumentSerieDefinitionFields = z.infer<
  typeof DocumentSerieDefinitionFieldsSchema
>;
export type PartialDocumentSerieDefinitionFields = z.infer<
  typeof DocumentSerieDefinitionFieldsSchema
>;
export type DocumentSerieDefinitionExtraFields = z.infer<
  typeof DocumentSerieDefinitionExtraFieldsSchema
>;
export type PartialDocumentSerieDefinitionExtraFields = z.infer<
  typeof PartialDocumentSerieDefinitionExtraFieldsSchema
>;
export type DocumentSerieDefinition = z.infer<
  typeof DocumentSerieDefinitionSchema
>;
